import { util } from "../../service/util";
const OSS = "https://sd235.oss-cn-shanghai.aliyuncs.com/";
const API = util.api(["ADDPLAYCOUNT"]);

let timer = undefined;
function hasClass(obj, cls) {
  return obj.className.match(new RegExp("(\\s|^)" + cls + "(\\s|$)"));
}

const audioInfo = {
  state: {
    // 播放器对象
    player: "",
    // 当前声音数据
    audio: {
      voiceId: "",
      filePath: "",
      voiceTitle: "",
      deployDubbing: {
        dubbingHead: "",
      },
    },
    // 储存的声音ids
    audioIds: {},
    // 储存的声音对象
    audioDatas: {},
    // 正在播放
    isPlaying: false,
    // 正在加载
    isWaiting: false,
    // 当前音乐的index索引
    currentIndex: 0,
    // 播放类型   1是自动播放  2是循环播放  3是随机播放
    playType: 1,
    // 当前播放的时间
    currentTime: 0,
    // 音乐的播放时长
    musicDuration: 0,
    // 音乐是否在加载
    musicLoadStart: false,
    // 展开状态
    isUnfold: false,
  },
  getters: {
    getEl: (state) => state.el,
    getIsPlaying: (state) => state.isPlaying,
    getIsWaiting: (state) => state.isWaiting,
    getCurrentIndex: (state) => state.currentIndex,
    getPlayType: (state) => state.playType,
    getCurrentTime: (state) => state.currentTime,
    getMusicDuration: (state) => state.duration,
    getMusicLoadStart: (state) => state.musicLoadStart,
    getPlayingItem: (state) => {
      let res = {
        voiceId: state.audio.voiceId,
        voiceImg: state.audio.deployDubbing.dubbingHead
          ? util.imgPath(state.audio.deployDubbing.dubbingHead)
          : "/static/global_player.png",
        isPlaying: state.isPlaying,
        isWaiting: state.isWaiting,
        voiceTitle: state.audio.voiceTitle,
        isUnfold: state.isUnfold,
      };
      return res;
    },
  },
  mutations: {
    // 初始化播放器
    _initPlayer(state, el) {
      state.player = el;
    },
    /**
     * 状态改变
     */
    _onPlaying(state) {
      state.isPlaying = true;
    },
    _onPause(state) {
      state.isPlaying = false;
    },
    _onWaiting(state) {
      state.isWaiting = true;
    },
    _onCanplay(state) {
      state.isWaiting = false;
    },
    _setUnfold(state, bool) {
      state.isUnfold = bool;
    },
    // 播放
    _play(state) {
      state.isPlaying = true;
      state.player.play();
    },
    // 暂停
    _pause(state) {
      state.isPlaying = false;
      state.player.pause();
    },
    // 切换
    _togglePlay(state) {
      if (state.isPlaying) {
        state.isPlaying = false;
        state.player.pause();
      } else {
        state.isPlaying = true;
        state.player.play();
      }
    },
    // 增加声音对象
    _addAudioDatas(state, datas) {
      state.audioDatas = {
        ...state.audioDatas,
        ...datas,
      };
    },
    // 更新播放信息
    _updatePlayerInfo(state, audioInfo) {
      state.currentTime = audioInfo.currentTime;
      state.duration = audioInfo.duration;
    },
    // 增加播放次数
    _addPlayCount(state, id) {
      util.kAjax(API.ADDPLAYCOUNT, { id: id });
    },
    // 播放结束
    playEnd(state) {},
  },
  actions: {
    initPlayer({ commit, state }, el) {
      commit("_initPlayer", el);
    },
    addAudioDatas({ commit, state }, datas) {
      // 单个的包装成数组
      !datas.length && (datas = [datas]);
      let res = {};
      datas.forEach((d, i) => {
        res[d.voiceId] = d;
      });
      commit("_addAudioDatas", res);
    },
    /**
     * 根据声音id播放
     * - 声音id
     */
    playById({ commit, state }, id) {
      let interval = 3500;
      commit("_setUnfold", true);
      timer && clearTimeout(timer);
      timer = setTimeout(() => {
        commit("_setUnfold", false);
      }, interval);
      /**
       * 未加载
       */
      if (!id) {
        if (!state.audio.voiceId) {
          return;
        }
        commit("_togglePlay");
        return;
      }
      /**
       * 判断是否正在播放
       * - 切换播放状态
       */
      if (state.audio.voiceId == id) {
        commit("_togglePlay");
        return;
      }
      /**
       * 根据id播放新的声音
       */
      let data = state.audioDatas[id];
      if (data) {
        state.audio = data;
        state.player.setAttribute("src", OSS + state.audio.filePath);
        commit("_play");
        commit("_addPlayCount", id);
      } else {
        console.warn("未找到声音id:" + id);
      }
    },
    /**
     * 根据声音对象播放
     */
    playByItem(state, item) {},
  },
};

export default audioInfo;



// WEBPACK FOOTER //
// ./src/store/modules/player.js